import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import Date from 'components/formaters/Date';
import { VoyageStatus } from 'models/VoyageModel';
import voyageFamily from 'recoil/atoms/voyageFamily';


const UpcomingVoyagesInner = () => {
    const {t} = useTranslation();
    const voyages = useRecoilValue(voyageFamily(VoyageStatus.Pending));
    const navigate = useNavigate();

    return (
        <Paper
            sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                height: 400,
            }}
        >
            <Typography component="h2" variant="h6" color="primary" gutterBottom>
                {t('upcoming_voyages')}
            </Typography>

            <TableContainer>
                <Table size="small" aria-label="voyage table">
                    <TableHead>
                        <TableRow>
                            <TableCell>{t('port')}</TableCell>
                            <TableCell>{t('doc_cut')}</TableCell>
                            <TableCell>{t('etd')}</TableCell>
                            <TableCell>{t('eta')}</TableCell>
                            <TableCell>{t('destination')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {voyages.map(v => (
                            <TableRow
                                key={v.id}
                                sx={{
                                    '&:last-child td, &:last-child th': {border: 0},
                                    cursor: 'pointer',
                                    '&:hover': {bgcolor: 'grey.50'},
                                }}
                                onClick={() => navigate(`/voyage/${v.id}`)}
                            >
                                <TableCell>{v.pol.name}</TableCell>
                                <TableCell><Date date={v.cutDate} short/></TableCell>
                                <TableCell><Date date={v.etd} short/></TableCell>
                                <TableCell><Date date={v.eta} short/></TableCell>
                                <TableCell>{v.pod.name}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};

const UpcomingVoyages = () => {
    return (
        <Suspense fallback={null}>
            <UpcomingVoyagesInner/>
        </Suspense>
    )
}

export default UpcomingVoyages;
